export const COMPARE_ADD_ITEM = 'COMPARE_ADD_ITEM';
export const COMPARE_REMOVE_ITEM = 'COMPARE_REMOVE_ITEM';
export const COMPARE_EMPTY = 'COMPARE_EMPTY';
export const COMPARE_TOGGLE = 'COMPARE_TOGGLE';
